import { useContext } from 'react';
import { TRANSITIONS } from 'shared/styles/variables';
import styled, { keyframes, ThemeContext } from 'styled-components';

import ImageLoadingKnobLeft from 'images/verify/spinner-animation/knob-left.svg';
import ImageLoadingKnobRight from 'images/verify/spinner-animation/knob-right.svg';
import ImageLoadingLoop from 'images/verify/spinner-animation/loop.svg';
import CustomizablePictograph from 'verify/components/CustomizablePictograph';
import ThemedSvg from 'verify/components/ThemedSvg';

const rotating = keyframes`
  from {
    transform: translate(-50%,-50%) rotate(0deg);
  }
  to {
    transform: translate(-50%,-50%) rotate(360deg);
  }
`;

const ThemedContainer = styled(ThemedSvg)`
  position: relative;
`;

const Loop = styled('div')`
  img,
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: ${rotating} 5s linear infinite;
  }
`;

const Scanner = styled('div')`
  display: inline-flex;
  align-items: center;
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
`;

const LoadingSpinner = () => {
  const theme = useContext(ThemeContext);
  const customPictographUrl = theme?.loadingPictographUrl;

  if (customPictographUrl) {
    return <CustomizablePictograph url='loadingPictographUrl' height='loadingPictographHeight' />;
  } else {
    return (
      <ThemedContainer id='loading-spinner' aria-busy aria-live='polite' role='alert'>
        <Loop>
          <ImageLoadingLoop />
        </Loop>

        <Scanner>
          <ImageLoadingKnobLeft />
          <ImageLoadingKnobRight />
        </Scanner>
      </ThemedContainer>
    );
  }
};

export default LoadingSpinner;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  49.9999% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
  `;

const FullScreenSpinnerContainer = styled('div')`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: ${fadeIn} ${TRANSITIONS.medium};
`;

export const FullScreenLoadingSpinner = () => (
  <FullScreenSpinnerContainer>
    <LoadingSpinner />
  </FullScreenSpinnerContainer>
);
